// extracted by mini-css-extract-plugin
module.exports = {"container":"ExperienceAbout_container__81FMt","title":"ExperienceAbout_title__34q3J","subTitle":"ExperienceAbout_subTitle__3Mmro","link":"ExperienceAbout_link__1kuWJ"};